// @flow

import {
  endpoints,
  createMultichatFunnelApi,
  editMultichatFunnelApi,
  getMultichatFunnelApi,
  getMultichatFunnelStagesApi,
  getMultichatFunnelsApi,
  setMultichatFunnelMainLaneApi,
  createMultichatFunnelStageApi,
  editMultichatFunnelStageApi,
  getLaneConversationsApi,
  sortFunnelConversationsApi,
  addConversationToFunnelApi,
  deleteMultichatFunnelLaneApi,
} from './api';

import type {
  CreateMultichatFunnel,
  UpdateMultichatFunnel,
  MultichatFunnel,
  MultichatFunnelLane,
  MultichatFunnelStage,
  CreateMultichatFunnelStage,
  PaginationResponse,
  Conversation,
  SortFunnelConversationsRequest,
} from '../../../entities';
import {buildRoute} from '../../../http';

export function getMultichatFunnelService(
  funnelId: string
): Promise<MultichatFunnel> {
  const route = buildRoute(endpoints.GET_MULTICHAT_FUNNEL, [funnelId]);
  return getMultichatFunnelApi(undefined, {
    route,
  }).toPromise();
}

export function createMultichatFunnelService(
  funnel: CreateMultichatFunnel
): Promise<MultichatFunnel> {
  return createMultichatFunnelApi(funnel).toPromise();
}

export function getMultichatFunnelsService(): Promise<MultichatFunnel[]> {
  return getMultichatFunnelsApi().toPromise();
}

export function editMultichatFunnelService(
  funnelId: string,
  funnel: UpdateMultichatFunnel
): Promise<MultichatFunnel> {
  const route = buildRoute(endpoints.EDIT_MULTICHAT_FUNNEL, [funnelId]);
  return editMultichatFunnelApi(funnel, {route}).toPromise();
}

export function getMultichatFunnelStagesService(): Promise<
  MultichatFunnelLane[]
> {
  return getMultichatFunnelStagesApi().toPromise();
}

export function createMultichatFunnelStageService(
  stage: CreateMultichatFunnelStage
): Promise<MultichatFunnelStage> {
  return createMultichatFunnelStageApi(stage).toPromise();
}

export function editMultichatFunnelStageService(
  stageId: string,
  stage: CreateMultichatFunnelStage
): Promise<MultichatFunnelStage> {
  const route = buildRoute(endpoints.EDIT_MULTICHAT_FUNNEL_STAGE, [stageId]);
  return editMultichatFunnelStageApi(stage, {route}).toPromise();
}

export function setMultichatFunnelMainLaneService(
  funnelId: string,
  laneId: string
): Promise<void> {
  return setMultichatFunnelMainLaneApi({
    startFunnelId: funnelId,
    startFunnelLaneId: laneId,
  }).toPromise();
}

export function getLaneConversationsService(
  funnelId: string,
  laneId: string,
  pagination: {page: number, size: number, identifier?: string}
): Promise<PaginationResponse<Conversation>> {
  const route = buildRoute(endpoints.GET_LANE_CONVERSATIONS, [
    funnelId,
    laneId,
  ]);
  return getLaneConversationsApi(pagination, {route}).toPromise();
}

export function sortFunnelConversationsService(
  funnelId: string,
  sortRequest: SortFunnelConversationsRequest
): Promise<void> {
  const route = buildRoute(endpoints.SORT_FUNNEL_CONVERSATIONS, [funnelId]);
  return sortFunnelConversationsApi(sortRequest, {route}).toPromise();
}

export function addConversationToFunnelService(
  funnelId: string,
  laneId: string,
  conversationsId: string[]
) {
  const route = buildRoute(endpoints.ADD_CONVERSATION_TO_FUNNEL, [funnelId]);
  return addConversationToFunnelApi(
    {
      funnelLaneId: laneId,
      crmConversationIds: conversationsId,
      operation: 'ASSOCIATE',
    },
    {route}
  ).toPromise();
}

export function deleteFunnelLaneService(laneId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_MULTICHAT_FUNNEL_LANE, [laneId]);
  return deleteMultichatFunnelLaneApi({route}).toPromise();
}
